export const commonPasswords = [
  "12345",
  "123456",
  "123456789",
  "test1",
  "password",
  "12345678",
  "zinch",
  "g_czechout",
  "asdf",
  "qwerty",
  "1234567890",
  "1234567",
  "Aa123456.",
  "iloveyou",
  "1234",
  "abc123",
  "111111",
  "123123",
  "dubsmash",
  "test",
  "princess",
  "qwertyuiop",
  "sunshine",
  "BvtTest123",
  "11111",
  "ashley",
  "00000",
  "000000",
  "password1",
  "monkey",
  "livetest",
  "55555",
  "soccer",
  "charlie",
  "asdfghjkl",
  "654321",
  "family",
  "michael",
  "123321",
  "football",
  "baseball",
  "q1w2e3r4t5y6",
  "nicole",
  "jessica",
  "purple",
  "shadow",
  "hannah",
  "chocolate",
  "michelle",
  "daniel",
  "maggie",
  "qwerty123",
  "hello",
  "112233",
  "jordan",
  "tigger",
  "666666",
  "987654321",
  "superman",
  "12345678910",
  "summer",
  "1q2w3e4r5t",
  "fitness",
  "bailey",
  "zxcvbnm",
  "fuckyou",
  "121212",
  "buster",
  "butterfly",
  "dragon",
  "jennifer",
  "amanda",
  "justin",
  "cookie",
  "basketball",
  "shopping",
  "pepper",
  "joshua",
  "hunter",
  "ginger",
  "matthew",
  "abcd1234",
  "taylor",
  "samantha",
  "whatever",
  "andrew",
  "1qaz2wsx3edc",
  "thomas",
  "jasmine",
  "animoto",
  "madison",
  "54321",
  "flower",
  "Password",
  "maria",
  "babygirl",
  "lovely",
  "sophie",
  "Chegg123",
  "computer",
  "qwe123",
  "anthony",
  "1q2w3e4r",
  "peanut",
  "bubbles",
  "asdasd",
  "qwert",
  "1qaz2wsx",
  "pakistan",
  "123qwe",
  "liverpool",
  "elizabeth",
  "harley",
  "chelsea",
  "familia",
  "yellow",
  "william",
  "george",
  "7777777",
  "loveme",
  "123abc",
  "letmein",
  "oliver",
  "batman",
  "cheese",
  "banana",
  "testing",
  "secret",
  "angel",
  "friends",
  "jackson",
  "aaaaaa",
  "softball",
  "chicken",
  "lauren",
  "andrea",
  "welcome",
  "asdfgh",
  "robert",
  "orange",
  "Testing1",
  "pokemon",
  "555555",
  "melissa",
  "morgan",
  "123123123",
  "qazwsx",
  "diamond",
  "brandon",
  "jesus",
  "mickey",
  "olivia",
  "changeme",
  "danielle",
  "victoria",
  "gabriel",
  "123456a",
  "0.00000000",
  "loveyou",
  "hockey",
  "freedom",
  "azerty",
  "snoopy",
  "skinny",
  "myheritage",
  "qwerty1",
  "159753",
  "forever",
  "iloveu",
  "killer",
  "joseph",
  "master",
  "mustang",
  "hellokitty",
  "school",
  "Password1",
  "patrick",
  "blink182",
  "tinkerbell",
  "rainbow",
  "nathan",
  "cooper",
  "onedirection",
  "alexander",
  "jordan23",
  "lol123",
  "jasper",
  "junior",
  "q1w2e3r4",
  "222222",
  "11111111",
  "benjamin",
  "jonathan",
  "passw0rd",
  "a123456",
  "samsung",
  "123",
  "love123",
  "picture1",
  "senha",
  "Million2",
  "aaron431",
  "qqww1122",
  "omgpop",
  "qwer123456",
  "unknown",
  "chatbooks",
  "20100728",
  "jacket025",
  "evite",
  "5201314",
  "Bangbang123",
  "jobandtalent",
  "default",
  "123654",
  "ohmnamah23",
  "zing",
  "102030",
  "147258369",
  "party",
  "myspace1",
  "asd123",
  "a123456789",
  "888888",
  "1234qwer",
  "147258",
  "999999",
  "159357",
  "88888888",
  "789456123",
  "anhyeuem",
  "1q2w3e",
  "789456",
  "6655321",
  "naruto",
  "123456789a",
  "password123",
  "686584",
  "iloveyou1",
  "25251325",
  "love",
  "987654",
  "princess1",
  "101010",
  "12341234",
  "a801016",
  "1111",
  "1111111",
  "yugioh",
  "fuckyou1",
  "asdf1234",
  "trustno1",
  "x4ivygA51F",
  "starwars",
  "michael1",
  "00000000",
  "jakcgt333",
  "babygirl1",
  "456789",
  "qwer1234",
  "hello123",
  "10203",
  "12345a",
  "131313",
  "123456b",
  "Sample123",
  "777777",
  "football1",
  "jesus1",
  "b123456",
  "333333",
  "1111111111",
  "a12345",
  "142536",
  "11223344",
  "angel1",
  "aa12345678",
  "123456q",
  "zxcvbn",
  "qazwsxedc",
  "target123",
  "asdasd123",
  "qweasdzxc",
  "tinkle",
  "q1w2e3r4t5",
  "1g2w3e4r",
  "gwerty123",
  "zag12wsx",
  "gwerty",
  "qweqwe",
  "12344321",
  "12qwaszx",
  "1234561",
  "Status",
  "qwerty12",
  "qweasd",
  "12345qwert",
  "1qazxsw2",
  "marina",
  "111222",
  "1234554321",
  "qqqqqq",
  "123654789",
  "12345q",
  "internet",
  "q1w2e3",
  "google",
  "mynoob",
  "qwertyui",
  "qwertyu",
  "monkey1",
  "nikita",
  "7758521",
  "87654321",
  "147852",
  "212121",
  "123789",
  "147852369",
  "123456789q",
  "qwe",
  "741852963",
  "123qweasd",
  "123456abc",
  "1q2w3e4r5t6y",
  "qazxsw",
  "232323",
  "999999999",
  "qwerty12345",
  "qwaszx",
  "1234567891",
  "456123",
  "444444",
  "qq123456",
  "xxx",
]
